import cn from 'classnames';
import React from 'react';

function ListOptionGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'div' : _ref$component;
  var Tag = component;
  return /*#__PURE__*/React.createElement(Tag, {
    tabIndex: "-1",
    role: "separator",
    className: cn(className, 'rw-list-optgroup')
  }, children);
}

export default ListOptionGroup;